import React from 'react';
import {View, ViewStyle, Image} from 'react-native';
import {Images} from '../../../assets';
import {Components, Theme, Font} from '@oneamerica/dxp-ui-components';
import {useSelector} from 'react-redux';

const Header = () => {
  // Temporarily getting the Users full name from the tax Document list API. To be updated later.
  const customerFullName = useSelector((state) => state.taxDocuments?.customerFullName);
  const { hasNYDocument, isTaxDocumentError } = useSelector((state) => state.taxDocuments);
  const shouldShowCustomerName = !isTaxDocumentError && customerFullName && !hasNYDocument;
  const renderOALogo = () => {
    return (
      <Components.Link
        accessibilityLabel="One America logo Image"
        accessibilityRole="button"
        testID="header:logo"
        focusStyle={
          {
            outlineWidth: 1,
            outlineColor: Theme.Color.ice4,
            outlineStyle: 'solid',
            outlineOffset: 1,
            padding: 0,
          } as ViewStyle
        }>
        <Image
          source={Images.oa_logo_color}
          alt="OneAmerica logo"
          style={{
            width: 159,
            height: 40,
          }}
          resizeMode="contain"
        />
      </Components.Link>
    );
  };

  return (
    <View testID="header" className="fixed w-full z-50">
      <View
        style={{backgroundColor: Theme.Color.oaBlue}}
        className="hidden md:py-2 md:w-full md:flex md:flex-row md:px-6 lg:px-8 md:items-center md:justify-between md:h-[30px]"
      />
      <View
        className="w-full h-[10px] md:border-t-0 md:h-[92px] px-6 md:px-8 py-8 md:py-0 pl-3 md:pl-6 lg:pl-[40px]"
        pointerEvents="box-none"
        style={{ backgroundColor: Theme.Color.white, paddingRight: 8 }}>
        <View
          className="w-full flex-row justify-around items-start mx-auto h-full items-center"
          pointerEvents="box-none">
          <View className="flex-row flex-1 items-center">{renderOALogo()}</View>
          <View className="flex-row h-full" />
        </View>
      </View>
      <View className="w-full lg:px-8">
        {/* Large screen layout Name + Plan Name */}
        {shouldShowCustomerName && (
        <View
        className="hidden lg:flex flex-col md:flex-row justify-between items-start md:items-center mt-5 mb-5 px-4 md:px-6"
        style={{paddingLeft: 15}}>
        <Components.Text.H1 style={{color: Theme.Color.oaBlue, marginBottom:8, fontFamily: Font.bold.fontFamily}}>
          {customerFullName || ' '}
        </Components.Text.H1>
      </View>
        )}
      </View>
    </View>
  );
};

export default Header;
